import React, { Component } from 'react';
import { FiBarChart2 } from 'react-icons/fi';

export default class StatisticsIcon extends Component {
  render() {
    return <FiBarChart2 size={17} />;
  }
}
